export class Asset {
  constructor(id: string) {
    this.id = id;
  }

  id: string;
  styles: any;
}
